import { render } from "./dropdownHotspot.vue?vue&type=template&id=53383e0c"
import script from "./dropdownHotspot.vue?vue&type=script&lang=js"
export * from "./dropdownHotspot.vue?vue&type=script&lang=js"

import "./dropdownHotspot.vue?vue&type=style&index=0&id=53383e0c&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__